<template>
  <div class="other-bg" :style="{ backgroundImage: 'url(' + BG + ')' }">
    <loading :active.sync="isLoading"></loading>
    <div class="container-cm">
      <div class="sidemap">
        <a href="#U" title="中央內容區塊" id="AU" accesskey="U" name="U">:::</a>
      <a href="/Sitemap" title="網站導覽">網站導覽</a>
      </div>
    </div>
    <div class="container-cm">
      <h1 class="logo">
        <a href="/" title="農科院農業課程報名及查詢系統:回首頁">
          <img src="../assets/images/LOGO.png" alt="農科院農業課程報名及查詢系統:回首頁" />
        </a>
      </h1>
      <main class="training-content">
        <div class="registration-title">
          <h2 :class="!ms_ie?'training-h2':'training-h2-ie'">課程查詢</h2>
          <a href="/Course/ParticipantSearch" title="前往報名查詢"
            >前往報名查詢</a
          >
        </div>
        <div class="table-line"></div>
        <div class="training-detail-container">
          <div class="training-detail-inquire">
            <h3 class="training-h3 mb-3">
              查詢條件<span>※請至少填入其中一個項目</span>
            </h3>
            <a href="#C" title="中央內容區塊" id="AC" accesskey="C" name="C"
              >:::</a
            >
            <div class="list">
              <label class="title" for="Title">課程名稱</label>
              <input
                class="content"
                id="Title"
                type="text"
                v-model="searchData.Title"
                title="請在此輸入課程關鍵字"
                placeholder="請填寫課程關鍵字"
              />
            </div>
            <div class="list">
              <label class="title" for="Number">課程代碼</label>
              <input
                class="content"
                id="Number"
                type="text"
                v-model="searchData.Number"
                title="請在此輸入課程代碼"
                placeholder="請填寫課程代碼"
              />
            </div>
            <!-- <div class="list">
              <label class="title" for="registerStart">報名開始日</label>
              <input
                class="content"
                id="registerStart"
                type="text"
                name="reDateBg"
                v-model="searchData.RegisterStart"
                title="報名開始日期選擇"
                placeholder="報名開始日期選擇"
              />
            </div>
            <div class="list">
              <label class="title" for="registerEnd">報名結束日</label>
              <input
                class="content"
                id="registerEnd"
                type="text"
                v-model="searchData.RegisterEnd"
                name="reDateEn"
                title="報名開始日期選擇"
                placeholder="報名開始日期選擇"
              />
            </div>
            <div class="list">
              <label class="title" for="trainingStart">課程開始日</label>
              <input
                class="content"
                id="trainingStart"
                type="text"
                v-model="searchData.TrainingStart"
                name="trDateBg"
                title="課程開始日期選擇"
                placeholder="課程開始日期選擇"
              />
            </div>
            <div class="list">
              <label class="title" for="trainingEnd">課程結束日</label>
              <input
                class="content"
                id="trainingEnd"
                type="text"
                v-model="searchData.TrainingEnd"
                name="trDateEn"
                title="課程結束日期選擇"
                placeholder="課程結束日期選擇"
              />
            </div> -->
            <div class="btn-box">
              <button
                class="btn light-green"
                href="#"
                title="送出搜尋條件"
                @click.prevent="submit"
              >
                送出
              </button>
              <button
                class="btn reset"
                href="#"
                title="重設搜尋條件"
                @click.prevent="reset"
              >
                重設
              </button>
            </div>
          </div>
          <div class="training-detail-result">
            <h3 class="training-h3">查詢結果</h3>
            <div class="table-container">
              <table
                id="resultTable"
                class="table tableTrain"
                style="width: 100%"
                ref="tbStatus"
              >
                <thead>
                  <tr>
                    <th id="trainingNumber">課程代碼</th>
                    <th id="trainingStartOn">上課日期</th>
                    <th id="trainingTitle">課程名稱</th>
                    <th id="trainingLocation">課程地點</th>
                    <th id="trainingRegister">報名日期</th>
                    <th id="trainingQuota">招募名額</th>
                    <th id="feature">功能</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, key) in tableData" :key="key">
                    <td headers="trainingNumber">{{ item.Number }}</td>
                    <td headers="trainingStartOn">
                      {{ item.StartOn | moment("subtract", "1911 years",'YYYY.MM.DD') | yearFormat }}<br />{{
                        item.StartOn | moment('HH:mm')
                      }}<br /> <span>~</span><br /> {{item.EndOn | moment("subtract", "1911 years",'YYYY.MM.DD') | yearFormat
                      }}<br />{{
                        item.EndOn | moment('HH:mm')
                      }}
                    </td>
                    <td headers="trainingTitle">{{ item.Title }}</td>
                    <td headers="trainingLocation">{{ item.Location }}</td>
                    <td headers="trainingRegister">{{ item.PublishStartOn | moment("subtract", "1911 years",'YYYY.MM.DD') | yearFormat }} ~<br />{{ item.PublishEndOn | moment("subtract", "1911 years",'YYYY.MM.DD') | yearFormat }}</td>
                    <td headers="trainingRegister">{{ item.Quota }}</td>
                    <td headers="feature">
                      <a
                        class="table-link"
                        :href="`/Course/Detail/${item.Id}`"
                        title="前往課程詳細資訊"
                        >課程<br />資訊</a
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </main>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Api from '@/assets/api/course';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css';
import Footer from '@/components/Footer.vue';
import $ from 'jquery';
import BG from '../assets/images/content_BG01.jpg';
import 'datatables.net-bs4';
import 'datatables.net-responsive-bs4';
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui/ui/i18n/datepicker-zh-TW';
import 'jquery-ui/themes/base/all.css';

export default {
  name: 'traininginquire',
  components: {
    Footer,
  },
  data() {
    return {
      BG,
      dt: {},
      trainingDetail: {},
      searchData: {
        Title: '',
        // RegisterStart: '',
        // RegisterEnd: '',
        // TrainingStart: '',
        // TrainingEnd: '',
        Number: '',
      },
      isChecked: false,
      // eslint-disable-next-line global-require
      scarecrowImg: require('../assets/images/scarecrow.png'),
      alertSet: {
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: '確定',
        confirmButtonAriaLabel: '確定',
        cancelButtonText: '取消',
        cancelButtonAriaLabel: '取消',
        closeButtonAriaLabel: '關閉視窗',
        reverseButtons: true,
        confirmButtonColor: '#4dba95',
        cancelButtonColor: '#bfbfbf',
        width: '1200px',
        html: '',
        focusConfirm: false,
      },
      choosedTraining: '',
      planOption: ['方案一', '方案二'],
      tableData: [
      ],
      isLoading: false,
      ms_ie: false,
    };
  },
  methods: {
    reset() {
      const vm = this;
      vm.searchData = {
        Title: '',
        // RegisterStart: '',
        // RegisterEnd: '',
        // TrainingStart: '',
        // TrainingEnd: '',
        Number: '',
      };
    },
    submit() {
      const vm = this;
      if (vm.searchData.Title === '' && vm.searchData.Number === '') {
        vm.$swal({
          icon: 'warning',
          text: '請至少填入一個項目',
          confirmButtonColor: '#4dba95',
          confirmButtonText: '確定',
          confirmButtonAriaLabel: '確定',
          focusConfirm: true,
        });
      } else {
        vm.isLoading = true;
        Api.getInquireTraining(
          vm.searchData,
        ).then((res) => {
          vm.isLoading = false;
          if (res.status === 200) {
            vm.tableData = res.data.Data.Courses;
            // console.log(res);
          } else {
            vm.$swal({
              icon: 'warning',
              text: '網路錯誤，請稍後再試。',
              confirmButtonColor: '#4dba95',
              confirmButtonText: '確定',
              confirmButtonAriaLabel: '確定',
              focusConfirm: true,
            });
          }
        });
      }
    },
  },
  created() {
    const vm = this;
    vm.trainingDetail = {
      Title: '2020年電性暨光學測試領域實驗室主管在職訓練 (臺北場/高雄場)', // 課程名稱
      Location: '高雄國際會議中心(603會議室)高雄市鹽埕區中路四路274號', // 課程地點
      Id: 'LAT20003', // 課程代碼
      Time: '2020.06.27  09:00~17:00', // 課程日期
      StartOn: '2020.05.01', // 報名日期 開始
      EndOn: '2020.06.01', // 報名日期 結束
      Quota: '150', // 招收名額
      Echelon: '1', // 報名梯次
      Left: '52', // 報名人數
      IsFull: false, // 是否滿額
      CaseOfficer: '王曉明', // 承辦人
      Organizer: '實驗室認證處', // 承辦單位
      Tel: '(03)5336333', // 連絡電話
      Explanation:
        '強化主導評審員評鑑一致性，您具主導評審員共識，創新評鑑技巧。', // 課程說明
      Propadeutik: 'NA', // 先修課程
      Price: '0', // 課程費用
      Restraints: '每一認證會員1名', // 招收限制
      Precautions:
        '1.為了愛護地球資源，活動現場供應飲水，請自備隨身水杯。<br>2.本次課程會於事前提供「課程作業」，敬請於開始前上網填寫，網址及填寫時間另行通知。', // 注意事項
      Link: 'a', // 附件
    };
    const ua = window.navigator.userAgent;
    const oldIe = ua.indexOf('MSIE ');
    const newIe = ua.indexOf('Trident/');
    if ((oldIe > -1) || (newIe > -1)) {
      vm.ms_ie = true;
    }
  },
  mounted() {
    const vm = this;
    $('#resultTable').DataTable({
      searching: false,
      ordering: true,
      columnDefs: [
        { orderable: false, targets: 2 },
        { orderable: false, targets: 3 },
        { orderable: false, targets: 4 },
        { orderable: false, targets: 6 },
      ],
      columns: [
        null,
        null,
        null,
        { width: '15%' },
        null,
        { width: '15%' },
        null,
      ],
      paging: false,
      info: false,
      destroy: true,
      language: {
        emptyTable: '目前沒有資料',
      },
    });
    vm.dt = $(vm.$refs.tbStatus).DataTable();
    // $.datepicker.setDefaults($.datepicker.regional['zh-TW']);
    $('[name ="reDateBg"]').datepicker({
      dateFormat: 'yy/mm/dd',
      onSelect(date) {
        vm.searchData.RegisterStart = date; // update date model
      },
    });
    $('[name ="reDateEn"]').datepicker({
      dateFormat: 'yy/mm/dd',
      onSelect(date) {
        vm.searchData.RegisterEnd = date; // update date model
      },
    });
    $('[name ="trDateBg"]').datepicker({
      dateFormat: 'yy/mm/dd',
      onSelect(date) {
        vm.searchData.TrainingStart = date; // update date model
      },
    });
    $('[name ="trDateEn"]').datepicker({
      dateFormat: 'yy/mm/dd',
      onSelect(date) {
        vm.searchData.TrainingEnd = date; // update date model
      },
    });
  },
  filters: {
    yearFormat(data) {
      return data.slice(1);
    },
  },
  watch: {
    tableData() {
      const vm = this;
      vm.dt.destroy();
      vm.$nextTick(() => {
        vm.dt = $(vm.$refs.tbStatus).DataTable({
          searching: false,
          ordering: true,
          columnDefs: [
            { orderable: false, targets: 2 },
            { orderable: false, targets: 3 },
            { orderable: false, targets: 4 },
            { orderable: false, targets: 6 },
            { width: '15%', targets: 1 },
            { width: '20%', targets: 3 },
            { width: '10%', targets: 5 },
          ],
          columns: [
            null,
            null,
            null,
            { width: '20%' },
            null,
            { width: '15%' },
            null,
          ],
          paging: false,
          info: false,
          destroy: true,
          language: {
            emptyTable: '查無資料',
          },
        });
      });
    },
    'searchData.RegisterStart': function (val) {
      $('[name ="reDateBg"]').val(val);
    },
    'searchData.RegisterEnd': function (val) {
      $('[name ="reDateEn"]').val(val);
    },
    'searchData.trDateBg': function (val) {
      $('[name ="reDateBg"]').val(val);
    },
    'searchData.trDateEn': function (val) {
      $('[name ="reDateBg"]').val(val);
    },
  },
};
</script>

<style lang="scss" scoped>

.other-bg {
  min-height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
}

.training-content {
  padding: 0 4rem 300px 4rem;
  @media (max-width: 1366px) {
    padding: 0 0 300px 0;
  }
}

.registration-title {
  h2 {
    display: inline-block;
  }
  span {
    font-size: 0.75rem;
    color: #ff3838;
  }
  a {
    color: #4dba95;
  }
}

.training-h3 {
  color: #4d8bbe;
  font-size: 1.5rem;
  span {
    font-size: 1rem;
    color: #ff3838;
  }
}

.table-line {
  height: 1px;
  background-color: #edf1f1;
  width: 100%;
}

#AC,#AU {
  color: transparent;
}

.training-detail-container {
  padding: 0.6rem 5rem;
  @media (max-width: 1366px) {
    padding: 0.6rem 1rem;
  }
  @media (max-width: 1024px) {
    padding: 0.6rem 0;
  }
}

.training-detail-inquire {
  // background-color: #fff;
  // border-radius: 1rem;
  // padding: 4.5rem 5rem 4.5rem 9rem;
  // box-shadow: 0 0 3px 3px rgba(227, 232, 232, 0.5);
  // @media (max-width: 1024px) {
  //   padding: 1.5rem;
  // }
  padding: 2rem 0;
  margin-bottom: 5rem;
  .list {
    display: flex;
    align-items: center;
    font-size: 1.1rem;
    color: #3e3e3f;
    letter-spacing: 1.5px;
    margin-bottom: 1rem;
    @media (max-width: 420px) {
      flex-direction: column;
      margin-bottom: 2rem;
      align-items: flex-start;
    }

    &.list-textarea {
      align-items: flex-start;
    }
    .title {
      min-width: 120px;
      display: inline-block;
      text-align: right;
      margin-right: 30px;
      span {
        color: #ff3838;
      }
      @media (max-width: 420px) {
        text-align: left;
      }
    }
    .content {
      width: 100%;
      display: inline-block;
    }
    input.content {
      padding: 0.75rem 0.75rem 0.5rem 0.75rem;
      border: unset;
      font-size: 1.1rem;
      border-bottom: 1px solid #535353;
    }
    select.content {
      width: 50%;
      padding: 0.5rem;
      border: unset;
      font-size: 1.1rem;
      border-bottom: 1px solid #535353;
    }
    textarea {
      height: 10rem;
      font-size: 1.1rem;
      padding: 0.5rem;
    }
  }
  .btn-box {
    display: flex;
    justify-content: center;
    padding-top: 5.5rem;
    @media (max-width: 767px) {
      flex-direction: column;
      align-items: center;
    }

    button:not(:last-child) {
      margin-right: 1rem;

      @media (max-width: 767px) {
        margin-right: 0;
        margin-bottom: 1.5rem;
      }
    }
  }
  .btn {
    display: block;
    color: #fff;
    border-radius: 5rem;
    padding: 0.5rem 0;
    width: 120px;
    font-size: 1.5rem;
    letter-spacing: 5px;
    text-decoration: none;
    text-align: center;
    border: none;
    cursor: pointer;

    &:focus {
      outline: 3px dashed #5da3ab;
    }

    &.light-green {
      background-color: #4dba95;
    }

    &.reset {
      background-color: #bfbfbf;
    }

    &.cancel {
      background-color: #d2d2d2;
    }
  }
}

.training-detail-result {
  h3 {
    margin-bottom: 1rem;
  }
  .table-container {
    background-color: #fff;
    padding: 1.5rem;
    box-shadow: 0 0 3px 3px rgba(227, 232, 232, 1);
    overflow-x: auto;
  }
}

.mb-3 {
  margin-bottom: 3rem;
}
.table-link {
  background-color: #4dba95;
  text-decoration: none;
  color: #fff;
  font-size: 1.1rem;
  width: 68px;
  height: 68px;
  line-height: 1.1;
  display: block;
  border-radius: 1rem;
  padding: 1rem;
}
</style>

<style lang="scss">
.training-h2 {
  background: linear-gradient(to bottom, #a0c8c0 0, #5aa3a8 100%);
  color: transparent;
  background-clip: text;
  -webkit-background-clip: text;
  font-size: 3rem;
  font-weight: bold;
  letter-spacing: 10px;
  margin-bottom: 1.5rem;

  @media (max-width: 360px) {
    letter-spacing: 1.5px;
  }
}

.training-h2-ie {
  color:  #5aa3a8;
  font-size: 3rem;
  font-weight: bold;
  letter-spacing: 10px;
  margin-bottom: 1.5rem;

  @media (max-width: 360px) {
    letter-spacing: 1.5px;
  }
}

.pop-check {
  text-align: center;
  font-size: 1.5rem;
  color: #f98d28;
  padding: 10px 0;
  input[type="checkbox"] {
    border: 2px solid #f98d28;
    width: 16px;
    height: 16px;
  }
}

// sweetalert 客製
.swal2-content {
  padding: 0 1rem;

  p {
    text-align-last: center;
    font-size: 1.1rem;
  }
  .mail {
    font-size: 1.5rem;
    padding: 1rem 0;
    @media (max-width: 420px) {
      font-size: 1.1rem;
    }
    span {
      color: #eb4141;
    }
  }
}

.swal2-styled.swal2-confirm,
.swal2-styled.swal2-cancel {
  font-size: 1.5rem;
  border-radius: 5rem;
  font-weight: bold;
  padding: 10px 55px;
}

.swal2-styled:focus {
  outline: 3px dashed #5da3ab;
}

// datatable 客製
.tableTrain th {
  border-top: none;
  color: #8bb75f;
  font-size: 1.1rem;
  text-align-last: left;
}

.tableTrain td {
  vertical-align: middle;
}

.tableTrain {
  tr {
    td:nth-child(1) {
      color: #307cb6;
      // font-size: 1.5rem;
    }
    td:nth-child(2) {
      // font-size: 1.1rem;
    }
    td:nth-child(3) {
      color: #307cb6;
      // font-size: 1.1rem;
    }
    td:nth-child(4) {
      // font-size: 1.5rem;
    }
    td:nth-child(5) {
      color: #307cb6;
      // font-size: 1.1rem;
    }
    td:nth-child(6) {
      color: #307cb6;
      // font-size: 1.1rem;
    }
    td:nth-child(7) {
      // font-size: 1.1rem;
      height: 100px;
      padding: 5px 0;
    }
    td {
      span {
        writing-mode: vertical-rl;
      }
    }
  }
}
</style>
